/* eslint-disable indent */
import { useMediaQuery, useTheme } from '@mui/material'

/**
 * Simplified form factor hook for paid consumer toolbar
 * Uses MUI theme breakpoints: mobile (< 600px), tablet (600px - 1199px), desktop (>= 1200px)
 */
const useFormFactor = () => {
  const { breakpoints } = useTheme()

  const isMobile = useMediaQuery(breakpoints.down('sm')) // < 600px
  const isTablet = useMediaQuery(breakpoints.between('sm', 'lg')) // 600px - 1199px
  const isDesktop = useMediaQuery(breakpoints.up('lg')) // >= 1200px

  const formFactor = isMobile
    ? 'mobile'
    : isTablet
    ? 'tablet'
    : isDesktop
    ? 'desktop'
    : undefined

  return { formFactor, breakpoints }
}

export default useFormFactor
